import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AppRouter from './AppRouter';
import './main.scss';

function App() {
  return <AppRouter />;
}

export default App;
